import React from 'react';
import {
  defaultUserPhoto,
  isMilitaryUser,
} from '../../../../shared/utils/Helpers';
import styles from './CreateEvent.module.css';
import AppMark from '../../../../shared/project-info/web-project-info/svgs/AppMark';
import {projectConfig} from '../../../../shared/project-info/projectConfig';

const InvitedUsersSearchList = ({user, onInviteUserHandler}) => {
  const {
    first_name,
    last_name,
    profile_photo_url,
    preferred_chapter,
    military_branch,
    military_status,
    leader,
  } = user;
  return (
    <li onClick={() => onInviteUserHandler(`${first_name} ${last_name}`)}>
      <img
        src={profile_photo_url || defaultUserPhoto}
        className={styles.invitedUsersItem}
      />
      <div>
        <div>
          <h3>{`${first_name} ${last_name}`}</h3>
          {/* {eagle_leader && <AppMark width={40} height={15} />} */}
        </div>
        {leader && (
          <h5 className={styles.eagleLeaderText}>
            {projectConfig.leaderRoleDisplay}
          </h5>
        )}
        <p>{projectConfig.showProfileChapter && preferred_chapter?.name}</p>
        <p>
          {military_status}
          {military_status && !isMilitaryUser(military_status)
            ? ` / ${military_branch}`
            : null}
        </p>
      </div>
    </li>
  );
};

export default InvitedUsersSearchList;
